<template>
<div>

	<div v-if="metrics">
		<div class="cards">
			<div class="card" v-for="(metrics) in metrics" :key="metrics.id">
				<div class="card__content">
					<div class="card__header" v-if="metrics.text || metrics.count">
						<div class="card__header__title" v-if="metrics.text">
							<h2>{{ metrics.text }}</h2>
						</div>
						<div class="card__header__counter">
							<p v-if="metrics.count">
								{{ metrics.count }}
							</p>
							<p v-else-if="metrics.count === 0">0</p>
						</div>
					</div>
					<div class="card__body">
						<ul v-if="metrics.sub_metrics">
							<li v-for="(sub_metrics) in metrics.sub_metrics" :key="sub_metrics.id" v-if="metrics.sub_metrics">
								{{ sub_metrics.text }}
							</li>
						</ul>
						<ul v-if="metrics.sub_metrics.length === 0">
							<li>
								{{ metrics.fallback_text }}
							</li>
						</ul>
						<div class="card__body__nav" v-for="(suggested_actions) in metrics.suggested_actions" :key="suggested_actions.id" v-if="suggested_actions">
							<p class="card__body__alert " v-bind:class="{ 'card__body__alert--positive' : suggested_actions.alert_is_positive }" v-if="suggested_actions.alert">{{ suggested_actions.alert }}</p>

							<router-link :to="suggested_actions.link" v-if="suggested_actions.link && suggested_actions.link_text">
								{{ suggested_actions.link_text }}
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else>
		<p class="empty-state">
			{{ 'no-data' | translate | capitalize }}
		</p>
	</div>
</div>

</template>
<script>
export default {
	name: 'overview',
	computed: {
		metrics() {
			return this.$store.state.metrics.overview.metrics;
		},
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/metrics/overview.vue